import { useEffect, useState } from "react";
import API from "../../api/api";
import Modal from "../../components/Modal";
import Toast from "../../components/Toast";

function SponsorTiers() {
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [formData, setFormData] = useState({
        tierId: null,
        tierName: "",
        displayOrder: 0
    });
    const [toast, setToast] = useState(null);

    const fetchList = () => {
        setLoading(true);
        console.log("Fetching sponsor tiers from /sponsor-tiers...");
        API.get("/sponsor-tiers")
            .then(res => {
                console.log("Sponsor Tiers received:", res.data);
                setList(res.data.sort((a, b) => a.DisplayOrder - b.DisplayOrder));
            })
            .catch(err => {
                console.error("Error fetching sponsor tiers:", err);
                console.error("Error details:", err.response?.data || err.message);
                setList([]);
            })
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        fetchList();
    }, []);

    const handleOpenModal = (tier = null) => {
        if (tier) {
            setEditMode(true);
            setFormData({
                tierId: tier.TierId,
                tierName: tier.TierName,
                displayOrder: tier.DisplayOrder
            });
        } else {
            setEditMode(false);
            setFormData({
                tierId: null,
                tierName: "",
                displayOrder: list.length + 1
            });
        }
        setIsModalOpen(true);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const params = new URLSearchParams({
                tierName: formData.tierName,
                displayOrder: formData.displayOrder
            }).toString();

            if (editMode) {
                await API.put(`/sponsor-tiers/${formData.tierId}?${params}`);
                showToast("Tier updated successfully");
            } else {
                await API.post(`/sponsor-tiers?${params}`);
                showToast("Tier created successfully");
            }
            setIsModalOpen(false);
            fetchList();
        } catch (err) {
            showToast("Error saving tier", "error");
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure? This might affect sponsors in this tier.")) {
            try {
                await API.delete(`/sponsor-tiers/${id}`);
                showToast("Tier deleted");
                fetchList();
            } catch (err) {
                showToast("Error deleting tier", "error");
            }
        }
    };

    const showToast = (message, type = "success") => {
        setToast({ message, type });
    };

    return (
        <div className="admin-card">
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
                <h2 style={{ margin: 0 }}>Sponsor Tiers</h2>
                <button className="btn btn-primary" onClick={() => handleOpenModal()}>+ Add Tier</button>
            </div>

            {loading ? (
                <p>Loading tiers...</p>
            ) : (
                <table className="admin-table">
                    <thead>
                        <tr>
                            <th>Tier Name</th>
                            <th>Display Order</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {list.map(x => (
                            <tr key={x.TierId}>
                                <td><strong>{x.TierName}</strong></td>
                                <td>{x.DisplayOrder}</td>
                                <td>
                                    <button className="btn btn-outline" onClick={() => handleOpenModal(x)} style={{ padding: "4px 8px", marginRight: "8px" }}>Edit</button>
                                    <button className="btn btn-outline" onClick={() => handleDelete(x.TierId)} style={{ padding: "4px 8px", color: "var(--danger)" }}>Delete</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}

            <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} title={editMode ? "Edit Tier" : "Add Tier"}>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Tier Name</label>
                        <input className="form-control" value={formData.tierName} onChange={e => setFormData({ ...formData, tierName: e.target.value })} required />
                    </div>
                    <div className="form-group">
                        <label>Display Order</label>
                        <input type="number" className="form-control" value={formData.displayOrder} onChange={e => setFormData({ ...formData, displayOrder: e.target.value })} required />
                    </div>
                    <div style={{ marginTop: "20px", display: "flex", justifyContent: "flex-end" }}>
                        <button type="button" className="btn btn-outline" onClick={() => setIsModalOpen(false)} style={{ marginRight: "10px" }}>Cancel</button>
                        <button type="submit" className="btn btn-primary">{editMode ? "Update" : "Create"}</button>
                    </div>
                </form>
            </Modal>

            {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}
        </div>
    );
}

export default SponsorTiers;